/* ==========================================================================
   GutNourish theme — pricing-plans.js
   The landing-page supply cards + the ladder. Reads real variants and native
   selling plans, adds straight to the cart.
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (c) { return window.formatMoney ? window.formatMoney(c) : '$' + (c / 100).toFixed(2); };

  /* Subscription apps name their plans however they like — Loop tends to emit
     things like "Delivery every 1 month". We print the name inside a sentence
     ("$164.95 billed every 3 months"), so normalise it rather than trusting it. */
  function cadencePhrase(name) {
    if (!name) return '';
    var s = String(name).toLowerCase().trim();
    s = s.replace(/^(delivery|deliver|subscription|subscribe|ships?)\s+/, '');
    s = s.replace(/^(once\s+)?every\s+1\s+/, 'every ');
    s = s.replace(/\s+/g, ' ').trim();
    if (s && !/^every\b/.test(s) && /^\d/.test(s)) s = 'every ' + s;
    return s;
  }

  function initPricingPlans(root) {
    var scope = root && root.querySelectorAll ? root : document;
    $$('[data-plans-json]', scope).forEach(function (node) { setup(node.closest('section') || document); });
  }

  function setup(section) {
    if (section.dataset.plansWired === 'true') return;
    section.dataset.plansWired = 'true';

    var jsonEl = $('[data-plans-json]', section);
    if (!jsonEl) return;

    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var variants = data.variants || [];
    if (!variants.length) return;

    var cards = $$('[data-plan-card]', section);
    var ladder = $('[data-ladder]', section);
    var S = data.strings || {};

    function variant(id) {
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return variants[0];
    }

    function cardState(card) {
      return {
        id: parseInt(card.getAttribute('data-variant'), 10),
        mode: card.getAttribute('data-mode')
      };
    }

    function offerFor(v, mode) {
      if (mode === 'subscribe' && v.sellingPlans && v.sellingPlans.length) {
        var plan = v.sellingPlans[0];
        return { price: plan.price, plan: plan, subscribing: true };
      }
      return { price: v.price, plan: null, subscribing: false };
    }

    function selectedCard() {
      return cards.filter(function (c) { return c.classList.contains('plan--selected'); })[0] || cards[0];
    }

    function paintCard(card) {
      var st = cardState(card);
      var v = variant(st.id);
      var o = offerFor(v, st.mode);
      var perTub = v.tubs ? Math.round(o.price / v.tubs) : o.price;

      var unit = $('[data-card-unit]', card);
      var total = $('[data-card-total]', card);
      var save = $('[data-card-save]', card);

      if (unit) unit.textContent = money(perTub);
      if (total) {
        total.innerHTML = o.subscribing
          ? '<b>' + money(o.price) + '</b> ' + cadencePhrase(o.plan.name)
          : '<b>' + money(o.price) + '</b> ' + (S.oneTime || 'one-time');
      }
      if (save) {
        var saving = o.subscribing ? (v.price - o.price) : (data.rrp ? (data.rrp * v.tubs - v.price) : 0);
        save.hidden = saving <= 0;
        save.textContent = (S.save || 'Save') + ' ' + money(saving) + (o.subscribing ? ' ' + (S.perDelivery || 'per delivery') : '');
      }

      $$('[data-card-mode]', card).forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(btn.getAttribute('data-card-mode') === st.mode));
      });
    }

    function paintLadder() {
      if (!ladder) return;
      var rungs = [];
      variants.forEach(function (v) {
        rungs.push({ v: v, mode: 'onetime', unit: v.tubs ? v.price / v.tubs : v.price });
        (v.sellingPlans || []).forEach(function (p) {
          rungs.push({ v: v, mode: 'subscribe', unit: v.tubs ? p.price / v.tubs : p.price });
        });
      });
      rungs.sort(function (a, b) { return a.unit - b.unit; });

      var live = cardState(selectedCard());
      var rrp = data.rrp || 0;

      ladder.innerHTML = rungs.map(function (r) {
        var isLive = r.v.id === live.id && r.mode === live.mode;
        var pct = rrp ? Math.max(0, Math.round((1 - r.unit / rrp) * 100)) : 0;
        var word = r.mode === 'subscribe' ? (S.subscribeWord || 'subscribe') : (S.oneTimeWord || 'one-time');
        return '<div class="ladder__row' + (isLive ? ' ladder__row--live' : '') + '">' +
          '<span><b>' + r.v.title + '</b> · ' + word + '</span>' +
          '<span class="ladder__bar"><i style="width:' + pct + '%"></i></span>' +
          '<span class="ladder__unit">' + money(Math.round(r.unit)) + '</span>' +
          '</div>';
      }).join('');
    }

    function paintSummary() {
      var st = cardState(selectedCard());
      var v = variant(st.id);
      var o = offerFor(v, st.mode);
      var what = $('[data-summary-what]', section);
      var detail = $('[data-summary-detail]', section);
      var perTub = v.tubs ? Math.round(o.price / v.tubs) : o.price;

      if (what) what.textContent = data.productTitle + ' — ' + v.title + (o.subscribing ? ', ' + cadencePhrase(o.plan.name) : '');
      if (detail) {
        detail.textContent = money(o.price) +
          (o.subscribing ? ' ' + (S.perDelivery || 'per delivery') : '') +
          ' · ' + money(perTub) + ' per tub';
      }
    }

    function render() {
      cards.forEach(paintCard);
      cards.forEach(function (c) {
        var on = c.classList.contains('plan--selected');
        var btn = $('[data-card-select]', c);
        if (btn) btn.textContent = on ? (S.selected || 'Selected') : (S.select || 'Select');
        var input = $('.plan__input', c);
        if (input) input.checked = on;
      });
      paintLadder();
      paintSummary();
    }

    function select(card) {
      cards.forEach(function (c) { c.classList.toggle('plan--selected', c === card); });
      render();
    }

    cards.forEach(function (card) {
      $$('[data-card-mode]', card).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          card.setAttribute('data-mode', btn.getAttribute('data-card-mode'));
          select(card);
        });
      });
      var sel = $('[data-card-select]', card);
      if (sel) sel.addEventListener('click', function (e) { e.stopPropagation(); select(card); });
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-card-mode]') || e.target.closest('[data-card-select]')) return;
        select(card);
      });
    });

    var atc = $('[data-plans-atc]', section);
    if (atc) {
      atc.addEventListener('click', function () {
        var st = cardState(selectedCard());
        var v = variant(st.id);
        var o = offerFor(v, st.mode);
        var payload = { items: [{ id: v.id, quantity: 1 }] };
        if (o.plan) payload.items[0].selling_plan = o.plan.id;

        atc.disabled = true;
        var label = atc.textContent;
        if (!window.addToCart) { atc.disabled = false; return; }
        window.addToCart(payload, atc)
          .then(function () { atc.textContent = S.added || 'Added'; })
          .catch(function () {})
          .then(function () {
            setTimeout(function () { atc.disabled = false; atc.textContent = label; }, 1400);
          });
      });
    }

    render();
  }

  window.initPricingPlans = initPricingPlans;
  if (document.readyState !== 'loading') initPricingPlans(document);
  else document.addEventListener('DOMContentLoaded', function () { initPricingPlans(document); });
})();
